import { useState } from "react";

const SECTIONS = [
  {
    id: "start",
    title: "Zanim zaczniesz",
    body: [
      { p: "Panel jest dostępny pod adresem /admin/login. Sesja wygasa po 8 godzinach — po tym czasie trzeba zalogować się ponownie." },
      { p: "Po pięciu błędnych próbach logowania dostęp z danego łącza zostaje zablokowany na 15 minut. To zabezpieczenie przed zgadywaniem hasła. Jeśli zablokujesz się przez pomyłkę, po prostu odczekaj." },
      { p: "Zmiany w zakładkach Rezerwacje, Wiadomości i Blog zapisują się od razu. Treść strony wymaga kliknięcia przycisku Zapisz." },
    ],
  },
  {
    id: "rezerwacje",
    title: "Rezerwacje",
    body: [
      { p: "Tabela pokazuje wszystkie zgłoszenia z formularza rezerwacji, od najnowszego. Kliknięcie w wiersz otwiera szczegóły: telefon, filar, forma sesji, intencja, obecny stan i wcześniejsze doświadczenie." },
      { p: "Status zmieniasz listą rozwijaną bezpośrednio w tabeli. Do wyboru są cztery wartości i służą wyłącznie Twojej orientacji — klient nie dostaje o nich powiadomienia." },
      {
        list: [
          "nowa — zgłoszenie przyszło, nic z nim jeszcze nie zrobiłaś",
          "potwierdzona — termin ustalony z klientem",
          "odbyta — sesja się odbyła",
          "anulowana — do niej nie doszło",
        ],
      },
      { p: "Usunięcie rezerwacji jest nieodwracalne. Kasuje ją z bazy razem z treścią zgłoszenia i danymi kontaktowymi. Jeśli chcesz tylko uprzątnąć widok, użyj statusu anulowana." },
    ],
  },
  {
    id: "wiadomosci",
    title: "Wiadomości",
    body: [
      { p: "Tu trafiają zgłoszenia z krótkiego formularza kontaktowego: imię, adres e-mail i treść. Cała wiadomość jest widoczna od razu, bez rozwijania." },
      { p: "Odpowiadasz z własnej skrzynki, poza panelem — panel nie wysyła odpowiedzi do klientów." },
      { p: "Usunięcie wiadomości jest nieodwracalne." },
    ],
  },
  {
    id: "blog",
    title: "Blog",
    body: [
      { p: "Przycisk Nowy artykuł otwiera formularz. Pola tytuł, adres, zajawka, treść i kategoria są wymagane." },
      {
        list: [
          "Tytuł — od 3 do 200 znaków",
          "Adres (slug) — końcówka odnośnika, np. wpisując uwolnienie-systemowe otrzymasz stronę /blog/uwolnienie-systemowe. Używaj małych liter, bez polskich znaków i spacji; myślnik zamiast spacji",
          "Zajawka — od 10 do 400 znaków, pokazuje się na liście artykułów",
          "Treść — pełny tekst artykułu",
          "Okładka — zdjęcie u góry artykułu",
        ],
      },
      { p: "Przełącznik publikacji decyduje, czy artykuł widzą odwiedzający. Wyłączony oznacza szkic: zapisany, widoczny tylko w panelu." },
      { p: "Zmiana adresu już opublikowanego artykułu psuje odnośniki, które ktoś mógł zapisać lub udostępnić. Jeśli artykuł krąży w sieci, lepiej adresu nie ruszać." },
    ],
  },
  {
    id: "tresc",
    title: "Treść strony",
    body: [
      { p: "Ta zakładka edytuje teksty i zdjęcia na stronie głównej: nagłówek powitalny, sekcję o Tobie, opisy usług, dane w stopce. To, co wpiszesz, zobaczą odwiedzający." },
      { p: "Zmiany pojawiają się na stronie dopiero po kliknięciu Zapisz. Przycisk Przywróć zapisane cofa niezapisane poprawki do ostatnio zapisanej wersji." },
      { p: "Każdy zapis tworzy wersję w historii — panel przechowuje dwadzieścia ostatnich. Przycisk Historia zmian pokazuje listę z datami; z każdej możesz wrócić do poprzedniego stanu. Przywrócenie samo w sobie też zapisuje się w historii, więc cofnięcie da się cofnąć." },
      { p: "Zdjęcia wgrywasz bezpośrednio w polach obrazków. Dozwolone formaty to JPG, PNG, WEBP i GIF, a pojedynczy plik nie może przekroczyć 8 MB. Większy plik zostanie odrzucony — zmniejsz go przed wgraniem." },
    ],
  },
  {
    id: "powiadomienia",
    title: "Powiadomienia (e-mail i Telegram)",
    body: [
      { p: "Zgłoszenia z obu formularzy zawsze zapisują się w panelu, niezależnie od tego, czy powiadomienia działają. Ustawienia decydują wyłącznie o tym, czy dodatkowo dostajesz o nich wiadomość — na skrzynkę, na Telegram, albo oboma kanałami naraz." },
      { p: "Oba kanały działają niezależnie od siebie. Możesz włączyć tylko e-mail, tylko Telegram, oba, albo żadnego — awaria jednego nie wpływa na drugi." },
      { p: "Dopóki żaden kanał nie jest skonfigurowany, nad statystykami widnieje ostrzeżenie (osobne dla e-maila i dla Telegramu). Nie znika ono przez przypadek — jeśli je widzisz, znaczy że o nowych zgłoszeniach nikt Cię nie informuje i trzeba zaglądać do panelu ręcznie." },
      { p: "Instrukcja wypełnienia pól — zarówno dla poczty, jak i dla Telegramu — znajduje się w zakładce Ustawienia, pod przyciskiem Jak to wypełnić przy każdej z sekcji. Dla Telegramu obejmuje ona założenie bota przez @BotFather i znalezienie Chat ID." },
      { p: "Gdy wysyłka się nie powiedzie (którymkolwiek kanałem), zgłoszenie mimo wszystko zostaje zapisane, a panel pokazuje dokładny powód błędu i liczbę zgłoszeń, o których nie zostałaś powiadomiona. Żadne zgłoszenie nie ginie z powodu awarii powiadomień." },
    ],
  },
  {
    id: "bezpieczenstwo",
    title: "Bezpieczeństwo",
    body: [
      { p: "Hasło do skrzynki pocztowej i token bota Telegram przechowywane są w postaci zaszyfrowanej i nigdy nie są pokazywane ponownie — także Tobie. Jeśli pole wygląda na puste, a widnieje w nim kropkowany zapis z dopiskiem zapisane, wartość jest ustawiona. Zostaw pole puste, by jej nie zmieniać." },
      { p: "Własne hasło do panelu zmienisz w zakładce Ustawienia, w sekcji Zmiana hasła — potrzebujesz do tego obecnego hasła." },
      { p: "Nie przekazuj nikomu danych logowania do panelu. Osoba z dostępem widzi wszystkie dane kontaktowe klientów oraz treść ich zgłoszeń." },
      { p: "Dane klientów z formularzy to dane osobowe. Usuwaj zgłoszenia, których już nie potrzebujesz." },
    ],
  },
];

export default function Manual() {
  const [open, setOpen] = useState(SECTIONS[0].id);

  return (
    <div data-testid="manual" className="max-w-3xl">
      <div className="mb-10">
        <h2 className="font-display text-2xl text-[#2B2B2B] mb-2">Instrukcja obsługi panelu</h2>
        <p className="text-sm text-[#5C6670] leading-relaxed">
          Krótki przewodnik po każdej zakładce. Kliknij nagłówek, aby rozwinąć.
        </p>
      </div>

      <div className="border-t border-[#E5E0D8]">
        {SECTIONS.map((s) => {
          const expanded = open === s.id;
          return (
            <div key={s.id} className="border-b border-[#E5E0D8]">
              <button
                onClick={() => setOpen(expanded ? null : s.id)}
                data-testid={`manual-section-${s.id}`}
                aria-expanded={expanded}
                className="w-full flex items-center justify-between gap-4 py-5 text-left group"
              >
                <span className="font-display text-lg text-[#2B2B2B]">{s.title}</span>
                <span className="text-[#8A9A86] text-sm shrink-0 tabular-nums">
                  {expanded ? "zwiń" : "rozwiń"}
                </span>
              </button>
              {expanded && (
                <div className="pb-7 space-y-4" data-testid={`manual-body-${s.id}`}>
                  {s.body.map((block, i) =>
                    block.list ? (
                      <ul key={i} className="space-y-2 pl-5">
                        {block.list.map((item, j) => (
                          <li key={j} className="text-sm text-[#2B2B2B] leading-relaxed list-disc marker:text-[#8A9A86]">
                            {item}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p key={i} className="text-sm text-[#2B2B2B] leading-relaxed">
                        {block.p}
                      </p>
                    )
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
